/**
 * Backend API origin (no trailing slash).
 * Used by axios in `src/Components/service/http_common.js`.
 */
const environment = {
  apiUrl: "https://staging-api.brokeragentbase.com",
};

export default environment;
